import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Lock } from "lucide-react";
import "./popMenu.scss";



interface NavbarPandingPopProps {
  showAccessDenied: boolean;
  setShowAccessDenied: (value: boolean) => void;

}

export const NavbarPandingPop: React.FC<NavbarPandingPopProps> = ({
  showAccessDenied,
  setShowAccessDenied,

}) => {
  return (
    <AnimatePresence>
      {showAccessDenied && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="access-modal-overlay"
          onClick={() => setShowAccessDenied(false)}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 50 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
            className="access-modal-container"
          >
            {/* Close Button */}
            <button
              onClick={() => setShowAccessDenied(false)}
              className="access-modal-close"
            >
              <X className="icon-close" />
            </button>

            {/* Content */}
            <div className="access-modal-content">
              {/* Animated Lock */}
              <motion.div
                className="access-modal-lock"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              >
                <motion.div
                  animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0, 0.5] }}
                  transition={{ duration: 2, repeat: Infinity }}
                  className="access-modal-ring"
                />
                <motion.div
                  className="access-modal-lock-circle-s"
                  animate={{ y: [0, -8, 0] }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                >
                  <motion.div
                    animate={{ rotate: [0, -5, 5, 0] }}
                    transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <svg
                      className="icon-locka"
                      strokeWidth={2}
                      width="134"
                      height="129"
                      viewBox="0 0 134 129"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_6085_26749)">
                        <path
                          d="M79 110C109.376 110 134 85.3757 134 55C134 24.6243 109.376 0 79 0C48.6243 0 24 24.6243 24 55C24 85.3757 48.6243 110 79 110Z"
                          fill="url(#paint0_linear_6085_26749)"
                        />
                        <g clip-path="url(#clip1_6085_26749)">
                          <path
                            d="M78.9998 14C101.644 14 119.999 32.3545 119.999 54.9988C119.999 77.6431 101.644 96 78.9998 96C56.3555 96 38.001 77.6428 38.001 54.9988C38.001 32.3548 56.3558 14 78.9998 14Z"
                            fill="#EBEBEB"
                          />
                          <path
                            d="M95.8822 53.7977H80.5077V35.8554C80.5077 34.4385 79.3599 33.293 77.9453 33.293C76.5307 33.293 75.3828 34.4385 75.3828 35.8554V56.3548C75.3828 57.7718 76.5307 58.9173 77.9453 58.9173H95.8822C97.2992 58.9173 98.4447 57.7718 98.4447 56.3548C98.4447 54.9455 97.2992 53.7977 95.8822 53.7977Z"
                            fill="#1959DB"
                          />
                          <path
                            d="M78.9998 14C56.3558 14 38.001 32.3545 38.001 54.9988C38.001 77.6431 56.3555 96 78.9998 96C101.644 96 119.999 77.6428 119.999 54.9988C119.999 32.3548 101.644 14 78.9998 14ZM78.9998 88.3129C60.6324 88.3129 45.6884 73.3689 45.6884 54.9988C45.6884 36.6314 60.6324 21.6874 78.9998 21.6874C97.3672 21.6874 112.311 36.6314 112.311 54.9988C112.311 73.3689 97.3672 88.3129 78.9998 88.3129Z"
                            fill="#063490"
                          />
                        </g>
                        <path
                          d="M0 105.12L36.4035 71L37.8996 73.0365L0 105.12ZM40.6272 129L73.7826 92.5363L76 93.5537L40.6272 129ZM14.0687 125.422L43.2137 97.4905L44.8001 98.8779L14.0679 125.422H14.0684L14.0687 125.422Z"
                          fill="#ECF0F1"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_6085_26749"
                          x1="79"
                          y1="0"
                          x2="79"
                          y2="110"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#57E4FF" />
                          <stop offset="1" stop-color="#0071ED" />
                        </linearGradient>
                        <clipPath id="clip0_6085_26749">
                          <rect width="134" height="129" fill="white" />
                        </clipPath>
                        <clipPath id="clip1_6085_26749">
                          <rect
                            width="82"
                            height="82"
                            fill="white"
                            transform="translate(38 14)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </motion.div>
                </motion.div>
              </motion.div>

              {/* Title */}
              {/* <motion.h3
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="access-modal-title"
              >
                Access Deniend
              </motion.h3> */}

              {/* Document Name */}
              {/* <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.4 }}
                className="access-modal-badge"
              >
                <span>{deniedDocument}</span>
              </motion.div> */}

              {/* Description */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="access-modal-desc"
              >
                Thank you for your request. It is currently under review by our Founder and will be addressed as soon as possible
              </motion.p>

              {/* Required Reading */}
              {/* <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                className="access-modal-requirements"
              >
                <p>Required Reading:</p>
                <div className="req-list">
                  {["Intro", "FAQ", "Fact Sheet"].map((doc, index) => (
                    <motion.span
                      key={doc}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.7 + index * 0.1 }}
                      className="req-item"
                    >
                      {doc}
                    </motion.span>
                  ))}
                </div>
              </motion.div> */}

              {/* CTA Button */}
              {/* <motion.button
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
                onClick={() => setShowAccessDenied(false)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="access-modal-btn"
              >
                Got it, I’ll read them first
              </motion.button> */}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
